import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wait-spinner',
  templateUrl: './wait.component.html' ,
  styleUrls: ['./wait.component.css']
})
export class WaitComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}